import { Role } from "../../pages/team-details/redux";

export const RoleTypeLabel: Record<string, Role> = {
  MANAGER: "manager",
  DEVELOPER: "developer",
  NON_DEVELOPER: "non-developer",
};
